// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-main-loader{
    left: 50% !important;
    margin-left:-100px;
    position: fixed !important;
    top: 50% !important;
    margin-top: -100px;
    width: 45px;
    z-index: 9000 !important;
  }
  
  .profile-main-loader .loader {
  position: relative;
  margin: 0px auto;
  width: 200px;
  height: 200px;
  }

  .profile-main-loader .loader:before {
  content: '';
  display: block;
  padding-top: 100%;
  }
  
  .circular-loader {
  animation: rotate 2s linear infinite;
  height: 100%;
  transform-origin: center center;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  margin: auto;
  }
  
  .loader-path {
  stroke-dasharray: 150,200;
  stroke-dashoffset: -10;
  animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;
  stroke-linecap: round;
  }
  
  @keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
  }

  @keyframes dash {
  0% {
    stroke-dasharray: 1,200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89,200;
    stroke-dashoffset: -35;
  }
  100% {
    stroke-dasharray: 89,200;
    stroke-dashoffset: -124;
  }
  }

  @keyframes color {
  0% {
    stroke: #ef7d00;
  }
  40% {
    stroke: #ef7d00;
  }
  66% {
    stroke: #ef7d00;
  }
  80%, 90% {
    stroke: #ef7d00;
  }
  }`, "",{"version":3,"sources":["webpack://./src/components/loading/loading.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,0BAA0B;IAC1B,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,wBAAwB;EAC1B;;EAEA;EACA,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb;;EAEA;EACA,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB;;EAEA;EAEQ,oCAAoC;EAC5C,YAAY;EAGJ,+BAA+B;EACvC,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ;;EAEA;EACA,yBAAyB;EACzB,sBAAsB;EAEd,wEAAwE;EAChF,qBAAqB;EACrB;;EASA;EACA;IAEU,yBAAyB;EACnC;EACA;;EAiBA;EACA;IACE,uBAAuB;IACvB,oBAAoB;EACtB;EACA;IACE,wBAAwB;IACxB,sBAAsB;EACxB;EACA;IACE,wBAAwB;IACxB,uBAAuB;EACzB;EACA;;EAiBA;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA","sourcesContent":[".profile-main-loader{\n    left: 50% !important;\n    margin-left:-100px;\n    position: fixed !important;\n    top: 50% !important;\n    margin-top: -100px;\n    width: 45px;\n    z-index: 9000 !important;\n  }\n  \n  .profile-main-loader .loader {\n  position: relative;\n  margin: 0px auto;\n  width: 200px;\n  height: 200px;\n  }\n\n  .profile-main-loader .loader:before {\n  content: '';\n  display: block;\n  padding-top: 100%;\n  }\n  \n  .circular-loader {\n  -webkit-animation: rotate 2s linear infinite;\n          animation: rotate 2s linear infinite;\n  height: 100%;\n  -webkit-transform-origin: center center;\n      -ms-transform-origin: center center;\n          transform-origin: center center;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  margin: auto;\n  }\n  \n  .loader-path {\n  stroke-dasharray: 150,200;\n  stroke-dashoffset: -10;\n  -webkit-animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;\n          animation: dash 1.5s ease-in-out infinite, color 6s ease-in-out infinite;\n  stroke-linecap: round;\n  }\n  \n  @-webkit-keyframes rotate {\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n  }\n  \n  @keyframes rotate {\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n  }\n\n  @-webkit-keyframes dash {\n  0% {\n    stroke-dasharray: 1,200;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 89,200;\n    stroke-dashoffset: -35;\n  }\n  100% {\n    stroke-dasharray: 89,200;\n    stroke-dashoffset: -124;\n  }\n  }\n\n  @keyframes dash {\n  0% {\n    stroke-dasharray: 1,200;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 89,200;\n    stroke-dashoffset: -35;\n  }\n  100% {\n    stroke-dasharray: 89,200;\n    stroke-dashoffset: -124;\n  }\n  }\n\n  @-webkit-keyframes color {\n  0% {\n    stroke: #ef7d00;\n  }\n  40% {\n    stroke: #ef7d00;\n  }\n  66% {\n    stroke: #ef7d00;\n  }\n  80%, 90% {\n    stroke: #ef7d00;\n  }\n  }\n\n  @keyframes color {\n  0% {\n    stroke: #ef7d00;\n  }\n  40% {\n    stroke: #ef7d00;\n  }\n  66% {\n    stroke: #ef7d00;\n  }\n  80%, 90% {\n    stroke: #ef7d00;\n  }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
